import { Box, Grid, makeStyles, Typography } from "@material-ui/core";
import React, { useState, useEffect } from "react";
import { useSelector } from "react-redux";
import { BookCard } from "../../../../components";
import { backend } from "../../../../api";
import { Skeleton } from "@material-ui/lab";
import { toast } from "react-toastify";
import { Pagination } from "@mui/material"; // Import Pagination

const useStyles = makeStyles((theme) => ({
  root: {
    border: `1px solid ${theme.palette.secondary.dark}`,
    borderRadius: "5px",
    marginTop: "30px",
    padding: "10px",
    [theme.breakpoints.down("md")]: {
      marginTop: "30px",
    },
  },
  tabHeading: {
    fontSize: "32px",
    fontWeight: 550,
    margin: "0",
  },
  loadingSkeleton: {
    "&:hover": {
      boxShadow: `0px 0px 15px 1px ${theme.palette.secondary.dark}`,
    },
    padding: 10,
    border: `1px solid ${theme.palette.secondary.dark}`,
    textAlign: "center",
  },
  bookTitle: {
    fontSize: "20px",
    fontWeight: 700,
    lineHeight: "24px",
    marginBottom: "10px",
    textAlign: "center",
  },
  mainPreOrderLabel: {
    display: "flex",
    justifyContent: "center",
  },
  preOrderLabel: {
    marginTop: "3px",
    backgroundColor: "yellow",
    fontSize: "13px",
    fontWeight: "bold",
    padding: "2px 6px",
  },
}));

function Wishlist(props) {
  const classes = useStyles();
  const { user } = props;
  const [wishlist, setWishlist] = useState();
  const [currentPage, setCurrentPage] = useState(1);
  const booksPerPage = 8; // Number of books per page

  useEffect(() => {
    fetchWishist();
  }, []);

  const fetchWishist = () => {
    backend
      .get(`/wishlist?customer=${user.user._id}`)
      .then((res) => {
        setWishlist(res.data.data[0]);
      })
      .catch((err) => {
        toast.error(err.response?.data.message);
      });
  };

  // Get current books
  const indexOfLastBook = currentPage * booksPerPage;
  const indexOfFirstBook = indexOfLastBook - booksPerPage;
  const currentBooks = wishlist?.book.slice(indexOfFirstBook, indexOfLastBook);

  const handlePageChange = (event, value) => {
    setCurrentPage(value);
  };

  return (
    <div className={classes.root}>
      <Box display="flex" justifyContent="space-between" alignItems="center">
        <h2 className={classes.tabHeading}>My Wishlist</h2>
      </Box>
      {wishlist ? (
        <Box>
          {wishlist.book.length > 0 ? (
            <Box my={3}>
              <Grid container spacing={2}>
                {currentBooks.map((book, index) => (
                  <Grid item xs={12} md={4} lg={3} key={index}>
                    <BookCard
                      title={
                        <div className={classes.bookTitle}>
                          {book.book_title}
                          <div className={classes.mainPreOrderLabel}>
                            {book.pre_order && (
                              <span className={classes.preOrderLabel}>
                                Pre-Order
                              </span>
                            )}
                          </div>
                        </div>
                      }
                      price={
                        book.price.digital_price
                          ? book.price.digital_price
                          : "Soon"
                      }
                      cover={book.book_cover}
                      bookId={book._id}
                    />
                  </Grid>
                ))}
              </Grid>
              {wishlist.book.length > booksPerPage && (
                <Box display="flex" justifyContent="center" mt={4}>
                  <Pagination
                    count={Math.ceil(wishlist.book.length / booksPerPage)}
                    page={currentPage}
                    onChange={handlePageChange}
                    sx={{
                      "& .MuiPaginationItem-root": {
                        "&:hover": {
                          backgroundColor: "#FECE00",
                        },
                      },
                      "& .Mui-selected": {
                        backgroundColor: "#FECE00",
                        color: "#000",
                      },
                      "& .MuiPaginationItem-ellipsis": {
                        color: "#FECE00",
                      },
                    }}
                  />
                </Box>
              )}
            </Box>
          ) : (
            <Box>
              <Typography
                variant="h2"
                color="error"
                style={{ margin: "30px auto" }}
              >
                No Books in Your Wishlist
              </Typography>
            </Box>
          )}
        </Box>
      ) : (
        <Box>
          <Grid container spacing={2} style={{ marginTop: 20 }}>
            <Grid item xs={12} md={4} lg={3}>
              <Box className={classes.loadingSkeleton}>
                <Skeleton
                  variant="rect"
                  width="80%"
                  height={250}
                  style={{ margin: "0 auto" }}
                />
                <Skeleton
                  variant="rect"
                  width="90%"
                  height={30}
                  style={{ margin: "20px auto" }}
                />
                <Skeleton animation="wave" />
                <Skeleton
                  variant="rect"
                  width={150}
                  height={40}
                  style={{ margin: "10px auto" }}
                />
              </Box>
            </Grid>
            <Grid item xs={12} md={4} lg={3}>
              <Box className={classes.loadingSkeleton}>
                <Skeleton
                  variant="rect"
                  width="80%"
                  height={250}
                  style={{ margin: "0 auto" }}
                />
                <Skeleton
                  variant="rect"
                  width="90%"
                  height={30}
                  style={{ margin: "20px auto" }}
                />
                <Skeleton animation="wave" />
                <Skeleton
                  variant="rect"
                  width={150}
                  height={40}
                  style={{ margin: "10px auto" }}
                />
              </Box>
            </Grid>
            <Grid item xs={12} md={4} lg={3}>
              <Box className={classes.loadingSkeleton}>
                <Skeleton
                  variant="rect"
                  width="80%"
                  height={250}
                  style={{ margin: "0 auto" }}
                />
                <Skeleton
                  variant="rect"
                  width="90%"
                  height={30}
                  style={{ margin: "20px auto" }}
                />
                <Skeleton animation="wave" />
                <Skeleton
                  variant="rect"
                  width={150}
                  height={40}
                  style={{ margin: "10px auto" }}
                />
              </Box>
            </Grid>
          </Grid>
        </Box>
      )}
    </div>
  );
}

export default Wishlist;
